export default __webpack_public_path__ + "static/media/leftArrowActive.b1fefe38.svg";